import { PreRequestStatus } from "../../types/PreRequest";

export const preRequestStatusesMap: { [status in PreRequestStatus]: string } = {
  IN_PROGRESS: "En revisión",
  APPROVED: "Aprobada",
  REJECTED: "Rechazada"
};
